module.exports = "/_next/static/images/CartAbandonmentDesktop-b005a871c985c8e622cccc2299e10580.webp";